import type { HubNavigationProps } from "@/types/help-hub/presentation";

export const HubNavigation = ({ hub }: HubNavigationProps) => {
  const topics = hub.topics.filter(topic => topic.guides.length > 0);
  return (
    <nav className="hub-support-navigation hub-page-width" aria-label="Support centre sections">
      <span>Help starts here</span>
      <div>
        {topics.length > 0 && <a href="#guides">Guides</a>}
        {topics.length > 1 && <a href="#help-topics">Help by topic</a>}
        {hub.questions.length > 0 && <a href="#questions">Questions</a>}
        {hub.downloads.length > 0 && <a href="#downloads">Manuals & documents</a>}
        <a href="#ways-in">Get in touch</a>
        {hub.showApp && <a href="#app">Get the app</a>}
      </div>
    </nav>
  );
};
